import { roleBasedTransitions } from "src/redux/slices/purchase-order";

export const canUserTransition = (
  from: string,
  to: string,
  userRelevantRoles: Set<string>
): boolean => {
  return roleBasedTransitions.some(
    (t) =>
      t.from === from &&
      t.to === to &&
      t.roles.some((role) => userRelevantRoles.has(role))
  );
};
